import styled from 'styled-components';

export const Container = styled.div`
  background: linear-gradient(
    180deg,
    rgba(18, 18, 18, 0.12) 0%,
    rgba(18, 18, 18, 0.28) 100%
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* min-height, não height: com altura fixa de 100vh o cartão de login era
     cortado sem rolagem em janelas mais baixas (notebook 1366x768 com a
     barra do navegador, por exemplo). Assim continua centralizado quando
     sobra espaço e a página rola quando não sobra. */
  min-height: 100vh;
  gap: 2rem;
  /* Referência para o rodapé, que fica ancorado na base da tela. */
  position: relative;
  padding-bottom: 3rem;

  > img {
    max-height: 100px;
    filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.25));
  }

  @media (max-width: 600px) {
    > img {
      height: auto;
      width: 180px;
    }
  }
`;

export const Content = styled.div`
  width: 450px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  border-radius: var(--radius-lg);

  /* Vidro flutuante sobre a imagem de fundo. */
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(16px) saturate(115%);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 14px 34px rgba(18, 18, 18, 0.2),
    0 2px 8px rgba(18, 18, 18, 0.08);

  p {
    margin-top: 0.5rem;
    color: var(--feedback-danger);
  }

  img {
    width: 75px;
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 80%;
    gap: 0.5rem;
    margin-bottom: -1rem;

    > button {
      margin-top: 1rem;
    }
  }

  a {
    margin-top: 2rem;
    color: var(--muted-foreground);
    font-size: 0.85rem;
    transition: color 0.2s;

    &:hover {
      color: var(--primary-hover);
    }
  }

  @media (max-width: 600px) {
    width: 90%;

    img {
      width: 80px;
    }

    form {
      width: 90%;
    }
  }
`;

/* ---- Modal de redefinição de senha ---- */

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(18, 18, 18, 0.45);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  z-index: 9999;
`;

export const ModalCard = styled.div`
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(16px) saturate(115%);
  border: 1px solid rgba(255, 255, 255, 0.65);
  border-radius: var(--radius-lg);
  padding: 2rem;
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 18px 48px rgba(18, 18, 18, 0.28);

  /* O overlay é fixo e centralizado: sem limite de altura, um modal mais alto
     que a janela ficaria com o topo e o rodapé inalcançáveis. */
  max-height: 100%;
  overflow-y: auto;
`;

export const ModalTitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--foreground);
  margin: 0;
`;

export const ModalSubtitle = styled.p`
  font-size: 0.85rem;
  color: var(--muted-foreground);
  margin: 0;
  line-height: 1.5;
`;

export const FieldLabel = styled.label`
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--stone-600);
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FieldInput = styled.input`
  padding: 0.6rem 0.75rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.9rem;
  font-family: var(--font-sans);
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(255, 188, 3, 0.3);
  }
`;

export const ErrMsg = styled.p`
  font-size: 0.8rem;
  color: var(--feedback-danger);
  margin: 0;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 0.5rem;
`;

export const BtnCancel = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  color: var(--muted-foreground);
  padding: 0.5rem 0.75rem;
`;

export const BtnSave = styled.button`
  background: var(--primary);
  color: var(--primary-foreground);
  border: none;
  border-radius: var(--radius-sm);
  padding: 0.6rem 1.5rem;
  font-weight: 700;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: var(--primary-hover);
  }
  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

/* Mesmo visual do antigo <Link to="/forgotPassword">, agora que o
   "Esqueci minha senha" abre um modal em vez de navegar para outra página. */
export const ForgotLink = styled.button`
  margin-top: 2rem;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--muted-foreground);
  font-size: 0.85rem;
  transition: color 0.2s;

  &:hover {
    color: var(--primary-hover);
  }
`;

export const RedefinirLink = styled.button`
  margin-top: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  color: var(--muted-foreground);
  text-decoration: underline;

  &:hover {
    color: var(--stone-700);
  }
`;

/* Ancora o rodapé na base da tela sem desalinhar o card, que segue centralizado. */
export const FooterSlot = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
`;
